import React, { Component } from 'react';
import { Modal } from 'antd';
import Wrapper from './style';
import ChoiceOfAssets from './ChoiceOfAssets';
import SelectAmount from './SelectAmount';
import Payment from './Payment';

class GetXht extends Component {
	state = {
		step: this.props.step,
		currency: this.props.currency,
		method: '',
		amount: 0
	};

	handleOk = () => {
		const { handleOk } = this.props;
		this.setState({ step: 1, timer: 60 }, handleOk);
	};

	handleCancel = () => {
		const { handleCancel } = this.props;
		this.setState({ step: 1, timer: 60 }, handleCancel);
	};

	renderBody = () => {
		let { userActions, coin, user, stat, handleCancel } = this.props;
		let filteredCoin = coin.filter(c => ['btc', 'eth', 'bch'].includes(c.value))
		const { step, currency, method, amount } = this.state;

		switch (step) {
			case 1:
				return (
					<ChoiceOfAssets
						coin={filteredCoin}
						user={user}
						actions={userActions}
						next={(currency) => {
							this.setState({ step: 2, currency });
						}}
						onCancel={handleCancel}
					/>
				);
			case 2:
				return (
					<SelectAmount
						currency={currency}
						stat={stat}
						next={(method, amount) => {
							this.setState({ step: 3, method, amount });
						}}
						onCancel={handleCancel}
					/>
				);
			case 3:
				return (
					<Payment
						method={method}
						amount={amount}
						currency={currency}
						user={user}
						next={this.handleOk}
						onCancel={handleCancel}
					/>
				);
			default:
				break;
		}
	};

	render() {
		const { visible, handleCancel } = this.props;
		const { step } = this.state;
		const width = step === 1 ? 390 : step === 2 ? 420 : 620;
		const title =
			step === 1
				? 'Charge Balance'
				: step === 2
				? 'Select Amount'
				: 'Charge XHT Account';
		return (
			<Modal
				visible={visible}
				title={title}
				footer={false}
				onCancel={handleCancel}
				width={width}
			>
				<Wrapper>{this.renderBody()}</Wrapper>
			</Modal>
		);
	}
}

GetXht.defaultProps = {
	visible: true,
	step: 1,
	currecny: 'none',
	handleCancel: () => {},
	handleOk: () => {}
};

export default GetXht;
